import type { RoundNumber, TeamName } from './game.types';

export const adminRealtimeEvents = {
  joinSession: 'admin:join-session',
  leaveSession: 'admin:leave-session',
  roundSubmitted: 'admin:round-submitted',
  teamReset: 'admin:team-reset',
} as const;

export const playerRealtimeEvents = {
  joinTeamSession: 'player:join-team-session',
  leaveTeamSession: 'player:leave-team-session',
  teamReset: 'player:team-reset',
} as const;

export interface AdminSessionSubscriptionPayload {
  sessionCode: string;
}

export interface PlayerTeamSessionSubscriptionPayload {
  sessionCode: string;
  teamName: TeamName;
}

export interface AdminRoundSubmittedEvent {
  type: 'roundSubmitted';
  sessionCode?: string;
  teamName: TeamName;
  roundNumber: RoundNumber;
  timestamp: string;
}

export interface AdminTeamResetEvent {
  type: 'teamReset';
  sessionCode?: string;
  teamName: TeamName;
  timestamp: string;
}

export interface PlayerTeamResetEvent {
  type: 'teamReset';
  sessionCode?: string;
  teamName: TeamName;
  timestamp: string;
}
